function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Component } from 'react';
import { View, TouchableHighlight } from 'react-native';
import Collapsible from "../index";
const COLLAPSIBLE_PROPS = ['align', 'collapsed', 'collapsedHeight', 'enablePointerEvents', 'duration', 'easing', 'style', 'onAnimationEnd', 'children'];
const VIEW_PROPS = ['accessibilityLabel', 'accessibilityLiveRegion', 'accessibilityRole', 'accessibilityState', 'accessibilityValue', 'accessible', 'children', 'importantForAccessibility', 'nativeID', 'onBlur', 'onClick', 'onClickCapture', 'onContextMenu', 'onFocus', 'onKeyDown', 'onKeyUp', 'onLayout', 'onMoveShouldSetResponder', 'onMoveShouldSetResponderCapture', 'onResponderEnd', 'onResponderGrant', 'onResponderMove', 'onResponderReject', 'onResponderRelease', 'onResponderStart', 'onResponderTerminate', 'onResponderTerminationRequest', 'onScrollShouldSetResponder', 'onScrollShouldSetResponderCapture', 'onSelectionChangeShouldSetResponder', 'onSelectionChangeShouldSetResponderCapture', 'onStartShouldSetResponder', 'onStartShouldSetResponderCapture', 'pointerEvents', 'style', 'testID', 'dataSet', 'onMouseDown', 'onMouseEnter', 'onMouseLeave', 'onMouseMove', 'onMouseOver', 'onMouseOut', 'onMouseUp', 'onScroll', 'onTouchCancel', 'onTouchCancelCapture', 'onTouchEnd', 'onTouchEndCapture', 'onTouchMove', 'onTouchMoveCapture', 'onTouchStart', 'onTouchStartCapture', 'onWheel', 'href', 'rel', 'target'];
export default class Accordion extends Component {
  _toggleSection(section) {
    if (!this.props.disabled) {
      const {
        activeSections,
        expandMultiple,
        onChange
      } = this.props;
      let updatedSections = [];

      if (activeSections.includes(section)) {
        updatedSections = activeSections.filter(a => a !== section);
      } else if (expandMultiple) {
        updatedSections = [...activeSections, section];
      } else {
        updatedSections = [section];
      }

      onChange && onChange(updatedSections);
    }
  }

  render() {
    const viewProps = {};
    const collapsibleProps = {};
    Object.keys(this.props).forEach(key => {
      if (COLLAPSIBLE_PROPS.includes(key)) {
        collapsibleProps[key] = this.props[key];
      } else if (VIEW_PROPS.includes(key)) {
        viewProps[key] = this.props[key];
      }
    });
    const {
      activeSections,
      containerStyle,
      sectionContainerStyle,
      expandFromBottom,
      sections,
      underlayColor,
      touchableProps,
      touchableComponent: Touchable,
      onAnimationEnd,
      renderContent,
      renderHeader,
      renderFooter,
      renderSectionTitle
    } = this.props;

    const renderCollapsible = (section, key) => /*#__PURE__*/React.createElement(Collapsible, _extends({
      collapsed: !activeSections.includes(key)
    }, collapsibleProps, {
      onAnimationEnd: () => onAnimationEnd(section, key)
    }), renderContent(section, key, activeSections.includes(key), sections));

    return /*#__PURE__*/React.createElement(View, _extends({
      style: containerStyle
    }, viewProps), sections.map((section, key) => /*#__PURE__*/React.createElement(View, {
      key: key,
      style: sectionContainerStyle
    }, renderSectionTitle(section, key, activeSections.includes(key)), expandFromBottom && renderCollapsible(section, key), /*#__PURE__*/React.createElement(Touchable, _extends({
      onPress: () => this._toggleSection(key),
      underlayColor: underlayColor
    }, touchableProps), renderHeader(section, key, activeSections.includes(key), sections)), !expandFromBottom && renderCollapsible(section, key), renderFooter && renderFooter(section, key, activeSections.includes(key), sections))));
  }

}

_defineProperty(Accordion, "defaultProps", {
  underlayColor: 'black',
  disabled: false,
  expandFromBottom: false,
  expandMultiple: false,
  touchableComponent: TouchableHighlight,
  renderSectionTitle: () => null,
  onAnimationEnd: () => null,
  sectionContainerStyle: {}
});